import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import BEM from '@polleverywhere/toolkit-lib/lib/mixins/_bem'
import Form from './form'
import tmpl from './templates/common.hamlc'

const renderError = function (state, error) {
  this.$('.component-auth__error').text(error || '')
}

const updateState = function (state) {
  const accountSubmittable = state.get('accountSubmittable')
  const submittable = !state.get('submitting') && accountSubmittable

  this.$('.component-auth__submit').prop('disabled', !submittable)
  state.set('submittable', submittable)
}

const updateCTA = function () {
  this.$('.component-auth__submit').text(this.cta)
}

/**
 * Base class for Auth forms (login, signup, reset password)
 *
 * To share logic validation and state
 *
 * Not to be used on it's own
 */
export default class AuthBase extends Backbone.View {
  get template () { return tmpl() }

  events () {
    return {
      'click button[type="submit"]': 'handleSubmit'
    }
  }

  initialize (options = {}) {
    _.defaults(options, {
      accountSubmittable: true,
      submittable: true,
      error: ''
    })

    this.state = new Backbone.Model(options)

    this.form = new Form({
      fields: this.fields,
      state: this.state
    })

    this.listenTo(this.state, 'change:accountSubmittable change:submitting', updateState.bind(this))
    this.listenTo(this.state, 'change:error', renderError.bind(this))
    this.listenTo(this.state, 'change:submitting', updateCTA.bind(this))
    this.listenTo(this.form, 'submit', this.handleSubmit)
    this.listenTo(this.form, 'error', (...args) => this.trigger('error', ...args))
    this.listenTo(this.form, 'view:action', (...args) => this.trigger('view:action', ...args))

    _.extend(this, BEM(this))
  }

  validate () {
    this.state.set('error', '')

    const isValid = this.form.validate()

    if (!isValid) {
      this.form.focusInvalid()
    }

    return isValid
  }

  handleSubmit () {
    throw new Error('Implement handleSubmit in subclass')
  }

  render () {
    this.trigger('view:action', 'view:auth', {
      className: this.className
    })
    this.$el.html(this.template)
    this.$el.addClass('component-auth__common')

    this.$('.component-auth__form').append(this.form.render().$el)
    updateCTA.call(this)

    return this
  }

  remove () {
    this.form.remove()
    super.remove()
  }
}
